import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

/* const store = new Vuex.Store({
    state:{
        loginState:0,    //0未登录  1已登录
    },
    mutations: {
        login_succ (state) {  //把状态改成已登陆
            // 变更状态
            state.loginState = 1
        },
        exit_succ (state) {  //把状态改成已登陆
            // 变更状态
            state.loginState = 0
        }
    }
}) */
var store = {
    state: {
        loginState: localStorage.loginState||0,
        userName: localStorage.userName||"",
    },
    setLoginAction (newType,newValue) {
        if(newValue){
            this.state.userName = newValue.userName
        }
        this.state.loginState = newType
        localStorage.loginState = newType
    }
  }

export default store